<template>
  <v-alert v-if="visible" :type="alert_type" dense text class="mb-4">
    <div class="d-flex align-center" style="gap: 12px">
      <div class="flex-grow-1">
        <div class="text-body-2">{{ message }}</div>
        <v-progress-linear
          v-if="active"
          :value="job.progress"
          color="secondary"
          height="4"
          rounded
          class="mt-2"
        ></v-progress-linear>
      </div>
      <v-btn
        v-if="!active && has_permission('rms_rate_change_log')"
        text
        small
        rounded
        :to="{ name: 'rms_rate_change_log' }"
      >
        {{ $t("rate_change_log") }}
      </v-btn>
      <v-btn v-if="!active" icon x-small @click="dismiss()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
import { mapGetters, mapState } from "vuex";

// Barra de progrés del recàlcul de tarifes calculades. No bloqueja res: la feina la
// fan tasques al backend i aquí només se n'ensenya l'estat. El polling viu al store,
// així que la barra es recupera sola en tornar a la pantalla o després d'un F5.
export default {
  name: "a-ref-recalc-progress",
  data: () => ({
    dismissed_job_id: null
  }),
  computed: {
    ...mapState({
      job: state => state.roomtype.ref_recalc_job
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      has_permission: "has_permission",
      active: "refRecalcActive"
    }),
    visible() {
      return !!this.job && this.dismissed_job_id !== this.job.id;
    },
    alert_type() {
      if (!this.job) return "info";
      switch (this.job.status) {
        case "done":
          return "success";
        case "partial":
          return "warning";
        case "error":
          return "error";
        default:
          return "info";
      }
    },
    message() {
      if (!this.job) return "";
      switch (this.job.status) {
        case "processing":
          return this.$t("recalculation_in_progress", {
            done: this.job.processed_dates,
            total: this.job.total_dates
          });
        case "done":
          return this.$t("recalculation_done", {
            changed: this.job.changed_rates
          });
        case "partial":
          return this.$t("recalculation_partial", {
            changed: this.job.changed_rates,
            errors: this.job.error_count
          });
        case "error":
          return this.$t("recalculation_error");
        default:
          return this.$t("recalculation_queued");
      }
    }
  },
  watch: {
    // Quan el recàlcul acaba, el pare recarrega la graella per veure l'estat real.
    "job.status": function(status, previous) {
      if (!previous || status === previous) return;
      if (["done", "partial", "error"].includes(status)) {
        this.$emit("finished", this.job);
      }
    },
    current_hotel() {
      // Un job és d'un hotel concret: en canviar d'hotel, tornem a preguntar.
      this.dismissed_job_id = null;
      this.$store.dispatch("clearRefRecalcJob");
      this.loadJob();
    }
  },
  methods: {
    loadJob() {
      this.$store
        .dispatch("fetchRefRecalcStatus")
        .then(job => {
          // Els jobs ja tancats d'una sessió anterior no han de reaparèixer.
          if (!job) return;
          if (["pending", "processing"].includes(job.status)) {
            this.$store.dispatch("startRefRecalcPolling");
          } else {
            this.dismissed_job_id = job.id;
          }
        })
        .catch(() => {
          // Un error consultant l'estat no ha de trencar la pantalla.
        });
    },
    dismiss() {
      this.dismissed_job_id = this.job ? this.job.id : null;
    }
  },
  mounted() {
    this.loadJob();
  },
  beforeDestroy() {
    this.$store.dispatch("stopRefRecalcPolling");
  }
};
</script>
